module.exports = __webpack_public_path__ + "static/sunsuper-nightsky-skyline-2-89985ed0d744bc12e90d41d31383a420.jpg";